import React from "react";
import Timely from "../../templates/Timely"

const EventsTemplate = ({ ...props }) => {
  return <Timely {...props} background={"#4D93FF"}/>;
};

export default EventsTemplate;
